
module.exports =  require('./lib/');



/*****************
 ** WEBPACK FOOTER
 ** ./~/socket.io-client/~/engine.io-client/index.js
 ** module id = 83
 ** module chunks = 0
 **/